/**
 * A component that uses react-router to render the current application screen
 * based on the URL.
 */

// Screens
import { Routes, Route } from 'react-router-dom';
import React from 'react';
import { Landing } from '../screens/landing';
import { EquipmentStatusOverview } from '../screens/equipment-status-overview';

const CurrentScreen = () => {
    return (
        <Routes>
            <Route path="/equipment-status" element={<EquipmentStatusOverview />} />
            <Route path="/" element={<Landing />} />
        </Routes>
    );
};

export default CurrentScreen;
